import { render, staticRenderFns } from "./SingleCategory.vue?vue&type=template&id=4757df1d&scoped=true"
import script from "./SingleCategory.vue?vue&type=script&lang=js"
export * from "./SingleCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4757df1d",
  null
  
)

export default component.exports